
import CryptoJS from 'crypto-js'
import md5 from 'js-md5'

// 加密密钥
const ENCRYPTION_SECRET = md5('europe@pc@h5@1#@7wllee57')

/**
 * 对象按照属性排序并拼接成字符串
 * @param {Object} params - 参数对象
 * @returns {string} 排序后的字符串
 */
export function sortAndJoinObjectProperties(params) {
  let str = ''
  Object.keys(params).sort().forEach(key => {
    if (key === 'optionIds') {
      str += `${key}=[${params[key].join(', ')}]&`
    } else if (params[key]) {
      str += `${key}=${params[key]}&`
    }
  })
  return str.slice(0, -1)
}

/**
 * 生成 HMAC-SHA256 签名
 * @param {Object} params - 请求参数对象
 * @param {string} params.nationCode - 国家代码
 * @param {string} params.channelId - 渠道 ID
 * @param {number} params.ts - 时间戳
 * @param {Array} [params.optionIds] - 选项 ID 数组（可选）
 * @returns {string} 签名结果（十六进制字符串）
 */
export function generateSign(params) {
  // 对参数进行排序并拼接
  const signStr = sortAndJoinObjectProperties(params)


  // 使用 HMAC-SHA256 生成签名
  const hmac = CryptoJS.HmacSHA256(signStr, ENCRYPTION_SECRET)

  // 返回十六进制格式的签名
  return hmac.toString(CryptoJS.enc.Hex)
}

/**
 * 构建签名所需的参数对象
 * @param {Object} data - 请求数据
 * @param {string} nationCode - 国家代码
 * @param {string} channelId - 渠道 ID
 * @param {number} ts - 时间戳
 * @returns {Object} 签名参数对象
 */
export function buildSignParams(data, nationCode, channelId, ts) {
  const params = {}


  // 复制 data 中的参数
  if (data) {
    Object.assign(params, data)
  }

  // 添加必需的签名字段
  params.nationCode = nationCode
  params.channelId = channelId
  params.ts = ts

  return params
}

export default {
  sortAndJoinObjectProperties,
  generateSign,
  buildSignParams
}